// eslint-disable-next-line no-shadow
enum SessionStatus {
    SCHEDULED = 'SCHEDULED',
    READY = 'READY',
    WAITING = 'WAITING',
    STARTED = 'STARTED',
    PAUSED = 'PAUSED',
    ENDED = 'ENDED',
    TIMED_OUT = 'TIMED_OUT',
}

export default SessionStatus;
